import { render, staticRenderFns } from "./CellActions.vue?vue&type=template&id=0bb0f608&"
import script from "./CellActions.vue?vue&type=script&lang=ts&"
export * from "./CellActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports